module.exports = __webpack_public_path__ + "img/fr_badge_google.7bf5d76e.png";